import { render, staticRenderFns } from "./MovAlertStrictedModal.vue?vue&type=template&id=dabf9100&scoped=true&lang=pug"
import script from "./MovAlertStrictedModal.vue?vue&type=script&lang=js"
export * from "./MovAlertStrictedModal.vue?vue&type=script&lang=js"
import style0 from "./MovAlertStrictedModal.vue?vue&type=style&index=0&id=dabf9100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabf9100",
  null
  
)

export default component.exports